import { render } from "./BaseVimeoPlayer.vue?vue&type=template&id=dbbc591a"
import script from "./BaseVimeoPlayer.vue?vue&type=script&lang=js"
export * from "./BaseVimeoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__